// Debug helper for troubleshooting Hustling Platform issues
// Add this temporarily to your components to debug auth/profile loading issues

import { supabase } from '../lib/supabase';

export const debugAuth = async () => {
  console.log('🔍 DEBUGGING AUTHENTICATION...');
  
  try {
    // Check Supabase connection
    console.log('📡 Supabase URL:', process.env.SB_URL);
    console.log('🔑 Supabase Key exists:', !!process.env.SB_API_KEY);
    
    // Check current session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    console.log('👤 Current Session:', session ? 'EXISTS' : 'NONE');
    console.log('📧 User Email:', session?.user?.email || 'N/A');
    console.log('🆔 User ID:', session?.user?.id || 'N/A');
    
    if (sessionError) {
      console.error('❌ Session Error:', sessionError);
    }
    
    // Check user profile if session exists
    if (session?.user) {
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single();
        
      console.log('👤 Profile exists:', !!profile);
      console.log('🎭 User Role:', profile?.role_type || 'NONE');
      console.log('✅ Email Verified:', profile?.email_verified || false);
      
      if (profileError) {
        console.error('❌ Profile Error:', profileError);
      }
      
      // Check if profile is missing but user exists
      if (!profile && !profileError?.message?.includes('No rows')) {
        console.warn('⚠️ ISSUE: User exists but no profile found!');
        console.log('🔧 FIX: Profile should be auto-created on signup');
      }
    }
    
    // Test basic database connection
    const { data, error } = await supabase
      .from('listings')
      .select('count(*)')
      .limit(1);
      
    if (error) {
      console.error('❌ Database Connection Error:', error);
    } else {
      console.log('✅ Database Connection: OK');
    }
    
    console.log('🔍 DEBUG COMPLETE - Check above for issues');
    
  } catch (error) {
    console.error('💥 Debug Helper Error:', error);
  }
};

// Call this from your browser console: window.debugAuth()
if (typeof window !== 'undefined') {
  window.debugAuth = debugAuth;
}

export const debugProfile = (user, profile, loading) => {
  console.log('🔍 AUTH CONTEXT DEBUG:');
  console.log('👤 User:', user ? 'EXISTS' : 'NONE');
  console.log('📋 Profile:', profile ? 'EXISTS' : 'NONE');
  console.log('⏳ Loading:', loading);
  
  if (user) {
    console.log('📧 Email:', user.email);
    console.log('🆔 ID:', user.id);
  }
  
  if (profile) {
    console.log('🎭 Role:', profile.role_type);
    console.log('📛 Name:', profile.display_name);
    console.log('✅ Verified:', profile.email_verified);
  }
};

// Quick test functions
export const testSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase.from('profiles').select('count(*)');
    return !error;
  } catch {
    return false;
  }
};

export const testAuth = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    return !!session;
  } catch {
    return false;
  }
};